import { render, staticRenderFns } from "./modalTemplate.vue?vue&type=template&id=3fa46bfe&scoped=true"
import script from "./modalTemplate.vue?vue&type=script&lang=js"
export * from "./modalTemplate.vue?vue&type=script&lang=js"
import style0 from "./modalTemplate.vue?vue&type=style&index=0&id=3fa46bfe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa46bfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa46bfe')) {
      api.createRecord('3fa46bfe', component.options)
    } else {
      api.reload('3fa46bfe', component.options)
    }
    module.hot.accept("./modalTemplate.vue?vue&type=template&id=3fa46bfe&scoped=true", function () {
      api.rerender('3fa46bfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/modalTemplate.vue"
export default component.exports